import React from 'react';
import { Circle, G, Line, Path, Polygon, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { FanSymbol } from '../primitives/FanSymbol';
import { DT } from '../tokens';

/** Tip speed — fan disc with diameter dimension, rotation arrow, tangent velocity vector. */
export function DiagramFanTipSpeed() {
  const cx = 175, cy = 125, r = 60;

  return (
    <DiagramCanvas>
      {/* Tip path (slightly outside fan) */}
      <Circle cx={cx} cy={cy} r={r + 6} fill="none" stroke={DT.varColor}
        strokeWidth="1" strokeDasharray="6,4" opacity={0.6} />

      {/* Fan with curved blades */}
      <Circle cx={cx} cy={cy} r={r} fill={DT.fill} stroke={DT.stroke} strokeWidth="2" />
      {[0, 60, 120, 180, 240, 300].map(deg => {
        const rad = deg * Math.PI / 180;
        const sx = cx + 10 * Math.cos(rad);
        const sy = cy + 10 * Math.sin(rad);
        const ex = cx + (r - 4) * Math.cos(rad + 0.5);
        const ey = cy + (r - 4) * Math.sin(rad + 0.5);
        const cp1x = cx + 28 * Math.cos(rad + 0.2);
        const cp1y = cy + 28 * Math.sin(rad + 0.2);
        return (
          <Path key={deg} d={`M${sx},${sy} Q${cp1x},${cp1y} ${ex},${ey}`}
            fill="none" stroke={DT.stroke} strokeWidth="2.2" strokeLinecap="round" />
        );
      })}
      <Circle cx={cx} cy={cy} r={6} fill={DT.stroke} />

      {/* Diameter line with arrowheads */}
      <Line x1={cx - r} y1={cy} x2={cx + r} y2={cy} stroke={DT.dim} strokeWidth="1" strokeDasharray="4,3" />
      <Polygon points={`${cx - r},${cy} ${cx - r + 7},${cy - 4} ${cx - r + 7},${cy + 4}`} fill={DT.dim} />
      <Polygon points={`${cx + r},${cy} ${cx + r - 7},${cy - 4} ${cx + r - 7},${cy + 4}`} fill={DT.dim} />
      <SvgText x={cx} y={cy - 4} fill={DT.dim} fontSize="9" fontFamily={DT.mono} textAnchor="middle">D (in)</SvgText>

      {/* Rotation arrow (curved) */}
      <Path d={`M${cx + r - 10},${cy - 24} A28,28 0 0 1 ${cx + r + 12},${cy + 4}`}
        fill="none" stroke={DT.varColor} strokeWidth="1.5" />
      <Polygon points={`${cx + r + 12},${cy + 4} ${cx + r + 16},${cy - 1} ${cx + r + 8},${cy + 0}`} fill={DT.varColor} />
      <SvgText x={cx + r + 18} y={cy + 16} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} fontWeight="700">RPM</SvgText>

      {/* Tangent velocity arrow at top */}
      <Line x1={cx} y1={cy - r} x2={cx + 50} y2={cy - r} stroke={DT.varColor} strokeWidth="2" />
      <Polygon points={`${cx + 50},${cy - r} ${cx + 44},${cy - r - 4} ${cx + 44},${cy - r + 4}`} fill={DT.varColor} />
      <SvgText x={cx + 56} y={cy - r + 4} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} fontWeight="700">TS</SvgText>

      {/* Labels */}
      <LeaderLine x1={cx} y1={cy - r - 8} x2={cx} y2={40} varName="D" desc="fan dia (in)" anchor="middle" />
      <LeaderLine x1={cx - r * 0.7} y1={cy - r * 0.7} x2={30} y2={50} varName="RPM" desc="rotation" anchor="start" />
      <LeaderLine x1={cx + r + 8} y1={cy - r + 4} x2={310} y2={210} varName="TS" desc="tip speed (FPM)" anchor="end" />

      <FormulaTag formula="TS = π · D(in) · RPM / 12   (FPM)" />
    </DiagramCanvas>
  );
}
